import { render, staticRenderFns } from "./UiDateInput.vue?vue&type=template&id=12fb352e&"
import script from "./UiDateInput.vue?vue&type=script&lang=js&"
export * from "./UiDateInput.vue?vue&type=script&lang=js&"
import style0 from "./UiDateInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports